import {type IBreadcrumbItem} from "@fluentui/react";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";

import PathConstants from "../../routes/pathConstants";

const useIsaacBreadCrumb = (): IBreadcrumbItem[] | undefined => {
  const location = useLocation();
  const navigate = useNavigate();
  const {t} = useTranslation(["common"]);

  const homeCrumb: IBreadcrumbItem = {
    id: "/",
    text: t("constructions"),
    key: "/",
    onClick: e => {
      e?.preventDefault();
      void navigate("/");
    },
  };

  const getTranslation = (url: string): string => {
    if (url.includes(PathConstants.CalculationsNote))
      return t(PathConstants.CalculationsNote);
    if (url.includes(PathConstants.Calculations)) return t("calculation");
    if (url.includes(PathConstants.Constructions)) return t("details");

    return url;
  };

  const pathSegments = location.pathname.split("/").filter(Boolean);

  if (pathSegments.length === 0) return [homeCrumb];

  const crumbs: IBreadcrumbItem[] = pathSegments
    .map((segment, index) => {
      const url = `/${pathSegments.slice(0, index + 1).join("/")}`;

      if (
        segment === PathConstants.Calculations ||
        segment === PathConstants.Constructions
      )
        return undefined;

      const crumb: IBreadcrumbItem = {
        id: segment.charAt(0).toUpperCase() + segment.slice(1),
        text: getTranslation(url),
        key: url,
        onClick: e => {
          e?.preventDefault();
          void navigate(url);
        },
      };

      return crumb;
    })
    .filter(Boolean) as IBreadcrumbItem[];
  crumbs.unshift(homeCrumb);

  return crumbs;
};

export default useIsaacBreadCrumb;
